"use client";

import Image from "next/image";

import type { ShopperBasketsTypes } from "commerce-sdk-isomorphic";

import { SalesPrice } from "@/components/salesPrice/salesPrice.component";
import { Text } from "@/components/text/text.component";

import { updateCartBasketItem } from "@/app/blu/(checkout-flow)/actions";
import { QuantityStepper } from "@/app/blu/(checkout-flow)/components/quantityStepper/quantityStepper.component";
import { GetCartLineProductsQueryResult } from "@/sanity.types";
import { urlFor } from "@/sanity/utils";

export const ConfiguratorAccessoryLineItem = ({
  product,
  item,
  action,
  isBonusLineItem,
}: ConfiguratorAccessoryLineItemProps) => {
  const image = product?.featuredImage?.image
    ? urlFor(product?.featuredImage?.image).width(120).height(120).url()
    : null;
  return (
    <div className="flex gap-4 border-b border-b-[#80808033] py-6">
      <div className="shrink-0">
        {image ? (
          <Image
            src={image}
            alt={product?.featuredImage?.alt ?? ""}
            width={80}
            height={80}
            className="rounded-lg object-cover"
          />
        ) : null}
      </div>
      <div className="flex flex-1 flex-col gap-2">
        <Text variant="body2">{product?.name || item.productName}</Text>
        {!isBonusLineItem ? (
          <QuantityStepper
            id={item.itemId ?? item.UUID}
            quantity={item.quantity}
            formAction={action ?? updateCartBasketItem}
          />
        ) : null}
      </div>
      <div className="flex shrink-0 items-start pt-0.5">
        <SalesPrice
          listPrice={item.listPrice}
          salesPrice={item.salesPrice}
          quantity={item.quantity}
          free={item.priceFree || isBonusLineItem}
          monthly={item.priceUnit === "monthly"}
          salesPriceClassName="subtitle-2"
          reverse
        />
      </div>
    </div>
  );
};

type ConfiguratorAccessoryLineItemProps = {
  product?: GetCartLineProductsQueryResult[number];
  item: ShopperBasketsTypes.ProductItem;
  isBonusLineItem?: boolean;
  action?: (
    prevState: ResponseMessage,
    formData: FormData,
  ) => ResponseMessage | Promise<ResponseMessage>;
};
